import { render, staticRenderFns } from "./ProgramaEditar.vue?vue&type=template&id=0c6daf8e"
import script from "./ProgramaEditar.vue?vue&type=script&lang=js"
export * from "./ProgramaEditar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports